import { render, staticRenderFns } from "./InfoGrid.vue?vue&type=template&id=a2bb0946"
import script from "./InfoGrid.vue?vue&type=script&lang=js"
export * from "./InfoGrid.vue?vue&type=script&lang=js"
import style0 from "./InfoGrid.vue?vue&type=style&index=0&id=a2bb0946&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports